import { gql } from '@apollo/client'

export const galleryCollectionRemoveByIdMutation = gql`
  mutation GalleryCollectionRemoveById($_id: String!) {
    galleryCollectionRemoveById(_id: $_id)
  }
`
